export const newItemId = () => window.crypto.randomUUID();
export const emptyConfig = () => ({ schema_version: 1, quantity_enabled: true,
  preference_enabled: true, notes_enabled: false, custom_items_allowed: true,
  required: false, min_quantity: 1, max_quantity: 100, quantity_step: 1, items: [] });

// Older API writes stored a JSON string inside JSONB. Keep those lists usable
// while the corrective migration is rolled out; never replace their items.
export const readItemListConfig = (raw) => {
  for (let layer = 0; typeof raw === "string" && layer < 5; layer++) {
    try { raw = JSON.parse(raw); } catch { return null; }
  }
  if (!raw || typeof raw !== "object" || !Array.isArray(raw.items) ||
      raw.items.some((item) => !item || typeof item.id !== "string" || typeof item.name !== "string")) return null;
  return { ...emptyConfig(), ...raw };
};

export const appendItems = (config, text, makeId = newItemId) => ({ ...config,
  items: [...config.items, ...text.split(/\r?\n/).map((name) => name.trim()).filter(Boolean)
    .map((name) => ({ id: makeId(), name, unit: "" }))],
});
export const answerText = (answers, questionId) => (answers || [])
  .filter((a) => String(a.survey_question_id) === String(questionId))
  .map((a) => a.value ? [...a.value.items.map((i) =>
    `${i.name}${i.quantity == null ? "" : ` × ${i.quantity}`}${i.unit ? ` ${i.unit}` : ""}${i.preference ? ` — ${i.preference}` : ""}`), a.value.notes].filter(Boolean).join("; ")
    : [a.answer, a.custom_answer].filter(Boolean).join(" — ")).filter(Boolean).join("; ");
export const csvSafe = (value) => typeof value === "string" && /^[\s]*[=+@-]/.test(value) ? `'${value}` : value;
export const itemExport = (results) => (results || []).flatMap((r) => (r.answers || []).filter((a) => a.value)
  .flatMap((a) => (a.value.items || []).map((item) => {
    const q = r.definition_snapshot?.questions?.find((q) => String(q.survey_question_id) === String(a.survey_question_id));
    return [r.survey_results_id, r.created_at, r.context_snapshot?.first_name || r.reservation?.first_name,
      r.context_snapshot?.last_name || r.reservation?.last_name,
      r.context_snapshot?.property || r.reservation?.pms_id,
      r.context_snapshot?.check_in || r.reservation?.check_in,
      q?.question || a.survey_question_id, item.name, item.quantity ?? "", item.unit,
      item.preference, a.value.notes].map(csvSafe);
  })));

const category = (question, names) => ({ question, question_type: "item-list", help_text: "Select only the items you need. Include pack size or brand in preferences.",
  question_options: [], config: { ...emptyConfig(), items: names.map((name) => ({ id: newItemId(), name, unit: "" })) } });
export const formTemplates = [
  { id: "grocery", name: "Grocery Pre-Stocking", build: () => [
    category("Fruit & Vegetables", ["Apples", "Bananas", "Red Grapes", "White Grapes", "Lemons", "Limes", "Strawberries", "Oranges", "Pears", "Grapefruit", "Pineapple", "Lettuce", "Avocado", "Tomatoes", "Potatoes"]),
    category("Condiments & Cooking", ["Ketchup", "Mustard", "Mayonnaise", "Salad Dressing", "Olive Oil", "Salt", "Pepper", "Pasta", "Rice"]),
    category("Breakfast & Snacks", ["Cereal", "Oatmeal", "Coffee", "Tea", "Crackers", "Cookies", "Chips", "Granola Bars"]),
    category("Drinks", ["Bottled Water", "Soda", "Juice", "Seltzer"]),
    category("Dairy", ["Milk", "Eggs", "Butter", "Yogurt", "Cheese"]),
    category("Frozen Foods", ["Pizza", "Vegetables", "Ice Cream"]),
    category("Bread", ["White Bread", "Wheat Bread", "Bagels", "Tortillas"]),
    category("Personal & Household Supplies", ["Shampoo", "Toothpaste", "Diapers", "Baby Wipes", "Paper Towels", "Dish Soap"]),
    category("Meats & Deli", ["Chicken", "Steaks", "Bacon", "Ground Beef", "Ham", "Turkey"]),
    { question: "May unavailable items be substituted?", question_type: "multiple-choice", question_options: ["Yes", "No"].map((answer) => ({ answer })) },
    { question: "Expected arrival time and additional instructions", question_type: "short-answer", question_options: [] },
  ] },
  { id: "equipment", name: "Equipment Rental Request", build: () => [category("Equipment", ["Bicycle", "Helmet", "Beach Chair", "Umbrella"])] },
  { id: "baby", name: "Baby Equipment Request", build: () => [category("Baby Equipment", ["Crib", "High Chair", "Stroller", "Baby Gate"])] },
];
